export const blockSelect = [
  { id: 0, value: "xx Asko" },
  { id: 1, value: "xx Asko1" },
  { id: 2, value: "xx Asko2" },
  { id: 3, value: "xx Asko3" },
  { id: 4, value: "xx Asko4" },
  { id: 5, value: "xx Asko5" },
];
export const devDays = [
  { id: 0, value: "1" },
  { id: 1, value: "3" },
  { id: 2, value: "7" },
  { id: 3, value: "14" },
  { id: 4, value: "28" },
  { id: 5, value: "72" },
];
export const interval = [
  { id: 0, value: "3" },
  { id: 1, value: "25" },
  { id: 2, value: "155" },
  { id: 3, value: "178" },
  { id: 4, value: "255" },
  { id: 5, value: "351" },
];
export const members = [
  { id: 0, address: "Polygon Address" },
  { id: 1, address: "Polygon Address" },
  { id: 2, address: "Polygon Address" },
  { id: 3, address: "Polygon Address" },
  { id: 4, address: "Polygon Address" },
  { id: 5, address: "Polygon Address" },
  { id: 6, address: "Polygon Address" },
  { id: 7, address: "Polygon Address" },
  { id: 8, address: "Polygon Address" },
  { id: 9, address: "Polygon Address" },
  { id: 10, address: "Polygon Address" },
];
export const walletbills = [
  { bill: "0xbB****r405", value: "150,000" },
  { bill: "0xbB****r405", value: "150,000" },
  { bill: "0xbB****r405", value: "337,545" },
  { bill: "0xbB****r405", value: "150,000" },
  { bill: "0xbB****r405", value: "150,000" },
  { bill: "0xbB****r405", value: "150,000" },
  { bill: "0xbB****r405", value: "150,000" },
  { bill: "0xbB****r405", value: "337,545" },
  { bill: "0xbB****r405", value: "150,000" },
  { bill: "0xbB****r405", value: "150,000" },
];
export const daoVoiting = [
  {
    id: 0,
    title: "DAO Tax Rate:",
    text: "DAO Tax Rate Avg: XX",
    percent: "00%",
  },
  { id: 1, title: "Approval Rate:", text: "Approval Rate: XX", percent: "00%" },
  {
    id: 2,
    title: "Development Tax Rate:",
    text: "Development Tax Rate Avg: XX",
    percent: "00%",
  },
  {
    id: 3,
    title: "Product Proposal Continuation Rate:",
    text: "Product Proposal Continuation Rate: XX",
    percent: "00%",
  },
  { id: 4, title: "Yes Rate:", text: "Yes Rate: XX", percent: "00%" },
];
export const proposalStatus = [
  { id: 0, name: "Prooposed", date: "February 18, 2021", checked: false },
  { id: 1, name: "Queued", date: "", checked: false },
  { id: 2, name: "Approved", date: "", checked: false },
  { id: 3, name: "Executed", date: "", checked: false },
];
export const ddfList = [
  {
    id: 0,
    product: "Asko.Finance",
    form: {
      link: "https://en.wikipedia.org/wiki/Cryptocurrency",
      submitted: true,
      date: "March 22, 2021",
      rate: "85%",
      approvals: "2",
      vetoes: 3,
    },
    queued: false,
    executed: true,
    proposed: true,
  },
  {
    id: 1,
    product: "Asko.Finance",
    form: {
      link: "https://en.wikipedia.org/wiki/Cryptocurrency",
      submitted: true,
      date: "March 22, 2021",
      rate: "85%",
      approvals: "2",
      vetoes: 3,
    },
    queued: true,
    executed: true,
    proposed: true,
  },
  {
    id: 2,
    product: "Asko.Finance",
    form: {
      link: "https://en.wikipedia.org/wiki/Cryptocurrency",
      submitted: true,
      date: "March 22, 2021",
      rate: "85%",
      approvals: "2",
      vetoes: 3,
    },
    queued: true,
    executed: true,
    proposed: true,
  },
  {
    id: 3,
    product: "Asko.Finance",
    form: {
      link: "https://en.wikipedia.org/wiki/Cryptocurrency",
      submitted: true,
      date: "March 22, 2021",
      rate: "85%",
      approvals: "2",
      vetoes: 3,
    },
    queued: false,
    executed: true,
    proposed: true,
  },
  {
    id: 4,
    product: "Asko.Finance",
    form: {
      link: "https://en.wikipedia.org/wiki/Cryptocurrency",
      submitted: true,
      date: "March 22, 2021",
      rate: "85%",
      approvals: "2",
      vetoes: 3,
    },
    queued: false,
    executed: true,
    proposed: true,
  },
  {
    id: 5,
    product: "Asko.Finance",
    form: {
      link: "https://en.wikipedia.org/wiki/Cryptocurrency",
      submitted: true,
      date: "March 22, 2021",
      rate: "85%",
      approvals: "2",
      vetoes: 3,
    },
    queued: false,
    executed: true,
    proposed: true,
  },
];

export const trade = [
  {
    id: 0,
    currency: {
      icon: "/assets/images/currency-icons/chain-link.png",
      name: "ChainLink",
    },
    apy: "0.03%",
    liquidity: "58.4k",
    borrowing: "818.51813",
    balance: "818,818.51813",
    star: 1,
  },
  {
    id: 1,
    currency: {
      icon: "/assets/images/currency-icons/rasko.png",
      name: "rASKO",
    },
    apy: "0.03%",
    liquidity: "21.7m",
    borrowing: "00.0000",
    balance: "16,547.085",
    star: 1,
  },
  {
    id: 2,
    currency: {
      icon: "/assets/images/currency-icons/BAT.png",
      name: "Basic Attention Token",
    },
    apy: "0.03%",
    liquidity: "1.4k",
    borrowing: "514.00074",
    balance: "00.0000",
    star: 1,
  },
  {
    id: 3,
    currency: {
      icon: "/assets/images/currency-icons/stablecoin.png",
      name: "DAI Stablecoin",
    },
    apy: "0.03%",
    liquidity: "58.4k",
    borrowing: "818.51813",
    balance: "818,818.51813",
    star: 1,
  },
  {
    id: 4,
    currency: {
      icon: "/assets/images/currency-icons/enjin.png",
      name: "Enjin Coin",
    },
    apy: "0.03%",
    liquidity: "58.4k",
    borrowing: "818.51813",
    balance: "818,818.51813",
    star: 1,
  },
  {
    id: 5,
    currency: {
      icon: "/assets/images/currency-icons/wrapped-ether.png",
      name: "Wrapped Ether",
    },
    apy: "0.03%",
    liquidity: "58.4k",
    borrowing: "818.51813",
    balance: "818,818.51813",
    star: 1,
  },
  {
    id: 6,
    currency: {
      icon: "/assets/images/currency-icons/renbtc.png",
      name: "renBTC",
    },
    apy: "0.03%",
    liquidity: "58.4k",
    borrowing: "818.51813",
    balance: "818,818.51813",
    star: 1,
  },
  {
    id: 7,
    currency: {
      icon: "/assets/images/currency-icons/uniswap.png",
      name: "Uniswap",
    },
    apy: "0.03%",
    liquidity: "58.4k",
    borrowing: "818.51813",
    balance: "818,818.51813",
    star: 1,
  },
  {
    id: 8,
    currency: {
      icon: "/assets/images/currency-icons/usdcoin.png",
      name: "USD Coin",
    },
    apy: "0.03%",
    liquidity: "58.4k",
    borrowing: "818.51813",
    balance: "818,818.51813",
    star: 1,
  },
];

export const farm = Array.from({ length: 10 }).map((_, id) => ({
  id,
  currencies: {
    icon: "/assets/images/currency-icons/sushi-btc.png",
    name: "SUSHI/BTC",
  },
  apy: (1 + Math.random() * 100).toFixed(2),
  claim: "117 rASKO",
  farming: Math.floor(1 + Math.random() * 1000),
  tvl: Math.floor(1 + Math.random() * 1000),
  percentOfPool: (1 + Math.random() * 100).toFixed(2),
  earned: Math.floor(1 + Math.random() * 500),
  pid: id,
}));

export const farmLpt = Array.from({ length: 10 }).map((_, id) => ({
  id,
  currencies: {
    icon: "/assets/images/currency-icons/alice.png",
    name: "LP Token - LR Alice",
  },
  apr: (1 + Math.random() * 100).toFixed(2),
  rewardsCycle: "30 days",
  earned: "25 000 rASKO",
  pid: id,
}));

export const farmHr = Array.from({ length: 10 }).map((_, id) => ({
  id,
  currencies: {
    icon: "/assets/images/currency-icons/alice.png",
    name: "HR Token Alice",
  },
  apr: (1 + Math.random() * 100).toFixed(2),
  rewardsCycle: "30 days",
  earned: "25 000 rASKO",
  pid: id,
}));

export const rewardsList = Array.from({ length: 10 }).map((_, id) => ({
  id,
  currencies: {
    icon: "/assets/images/currency-icons/alice.png",
    name: "Alice",
  },
  apr: 120,
}));

export const sf = [
  { id: 0, value: "LR WBNB" },
  { id: 1, value: "LR YEET" },
];

export const liquidityList = Array.from({ length: 5 }).map((_, id) => ({
  id: id + 1,
  first: {
    name: "LR WBNB",
    amound: Math.floor(10 + Math.random() * 100),
  },
  second: {
    name: "LP YEET",
    amound: Math.floor(100 + Math.random() * 900),
  },
  percent: (1 + Math.random() * 100).toFixed(2),
}));

export const rewards = {
  category: "1",
  apr: "15%",
  price: "0,01050450 $",
  claim: "23,456 rASKO",
  period: "123,456 rASKO",
  APR: "105%",
};

export const swapSettingsData = {
  gwei: ["Standard", "Fast", "Instant"],
  slippage: [0.1, 0.5, 1],
};
